import React from 'react';
import { Input } from './styles';

export const InputText = ({ $hasAnError, ...props }) => {
    return <Input $hasAnError={$hasAnError} {...props} />;
};
